import {
  Dialog as MuiDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { useAppDispatch, useAppSelector } from '../store/configureStore';
import { closeDialog } from '../store/dialogSlice';
import { useDialog } from '../hooks/useDialog';

export default function Dialog() {
  const dispatch = useAppDispatch();
  const { handleConfirm, handleCancel } = useDialog();
  const { isOpen, title, content, confirmText, cancelText } = useAppSelector(
    (state) => state.dialog
  );

  const onClose = () => {
    handleCancel();
    dispatch(closeDialog());
  };

  const onConfirm = () => {
    handleConfirm();
    dispatch(closeDialog());
  };

  return (
    <MuiDialog open={isOpen} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelText || 'Cancel'}</Button>
        <Button onClick={onConfirm} variant="contained">
          {confirmText || 'Confirm'}
        </Button>
      </DialogActions>
    </MuiDialog>
  );
}
